module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "face-images"
    }
  }, [_c('center', [_c('h2', [_vm._v("Face Images")])]), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._v("Loading...")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.faces), function(face) {
    return _c('div', {
      key: face.runtime_face_uuid,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": 'http://node-runner.p.owal.io:9612/faceimage/' + face.runtime_face_uuid,
        "height": "160dp"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": 'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&expanded=0',
        "height": "160dp"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": 'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&expanded=1&expand_ratio=0.05',
        "height": "160dp"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": 'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&expanded=1&expand_ratio=0.10',
        "height": "160dp"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": 'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&expanded=1&expand_ratio=0.15',
        "height": "160dp"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": 'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&expanded=1&expand_ratio=0.20',
        "height": "160dp"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": 'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&expanded=1&expand_ratio=0.25',
        "height": "160dp"
      }
    })])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "header-column"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "header-column"
  }, [_vm._v("Orig")]), _vm._v(" "), _c('div', {
    staticClass: "header-column"
  }, [_vm._v("Exp +0.05")]), _vm._v(" "), _c('div', {
    staticClass: "header-column"
  }, [_vm._v("Exp +0.10")]), _vm._v(" "), _c('div', {
    staticClass: "header-column"
  }, [_vm._v("Exp +0.15")]), _vm._v(" "), _c('div', {
    staticClass: "header-column"
  }, [_vm._v("Exp +0.20")]), _vm._v(" "), _c('div', {
    staticClass: "header-column"
  }, [_vm._v("Exp +0.25")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2470ed45","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaceImages.vue
// module id = 295
// module chunks = 1